import { toast } from '@/ui/UiToaster';
import type { AuthStatePublic, ActionPublic, AuthStateLite, ActionLite } from './types';

/**
 * Handles how that state changes in the `useAuth` hook.
 */
export function reducerPublic(state: AuthStatePublic, action: ActionPublic): AuthStatePublic {
  switch (action.type) {
    case 'INITIALISED':
      if (action.notify) {
        toast.success('PUBLIC-SDK успешно инициализирован');
      }
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        error: undefined,
      };
    case 'LOGIN_STARTED':
      return {
        ...state,
        isLoading: true,
      };
    case 'LOGIN_COMPLETE':
      toast.success('Токен успешно получен');
      return {
        ...state,
        isLoading: false,
        access_token: action.access_token,
        id_token: action.id_token,
        refresh_token: action.refresh_token,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        access_token: '',
        id_token: '',
      };
    case 'ERROR':
      toast.error(action.error);
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    default:
      return {
        ...state,
      };
  }
}

export function reducerLite(state: AuthStateLite, action: ActionLite): AuthStateLite {
  switch (action.type) {
    case 'INITIALISED':
      toast.success('SDK успешно инициализирован');
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        status: 'init',
        errorLite: undefined,
      };
    case 'SIGN_IN_STARTED':
      return {
        ...state,
        isLoading: true,
        status: 'phone',
      };
    case 'SIGN_IN_COMPLETE':
      return {
        ...state,
        isLoading: false,
        status: 'code',
      };
    case 'LOGIN_OTP_STARTED':
      return {
        ...state,
        isLoading: true,
        status: 'code',
      };
    case 'LOGIN_OTP_COMPLETE':
      toast.success('Токен успешно получен');
      return {
        ...state,
        isLoading: false,
        status: 'success',
        token: action.token,
        refresh_token: action.refresh_token ?? state.refresh_token,
      };
    case 'LOGOUT':
      return {
        ...state,
        isAuthenticated: false,
        token: '',
        refresh_token: '',
      };
    case 'ERROR':
      toast.error(action.error.message);
      return {
        ...state,
        isLoading: false,
        errorLite: action.error,
      };
    default:
      return {
        ...state,
      };
  }
};